// src/utilities/action-text.ts
import { html } from "lit";
function actionTextConversion(text, handleActionTextClicked) {
  if (!text) {
    return html``;
  }
  const textParts = text.split("[");
  return textParts.map((textPart, textPartIndex) => {
    const actionTextEnd = textPart.indexOf("]");
    if (actionTextEnd > 0) {
      const actionText = textPart.slice(0, actionTextEnd);
      const additionalText = actionTextEnd < textPart.length ? textPart.slice(actionTextEnd + 1) : "";
      const isActionTextLastLine = textPartIndex + 1 === textParts.length && actionTextEnd + 1 === textPart.length && textParts.length <= 2;
      return html`<span
							@click=${(event) => handleActionTextClicked(actionText, event)}
							class=${isActionTextLastLine ? "action-text action-text-last-line" : "action-text"}
							>${actionText}</span
						>
						${additionalText ? html`<span style="white-space: pre-wrap">${additionalText}</span>` : ""}`;
    } else {
      return html`<span style="white-space: pre-wrap">${textPart}</span>`;
    }
  }).reduce((previousValue, currentValue) => html`${previousValue}${currentValue}`);
}

export {
  actionTextConversion
};
